import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { BLOG_I18N_FR, BLOG_I18N_ES, BLOG_I18N_AR } from '../constants/blogArticleTranslations';
import {
  I18N_SECTION_EN,
  I18N_SECTION_FR,
  I18N_SECTION_ES,
  I18N_SECTION_AR,
} from '../constants/i18nSectionTranslations';

const translations = {
  en: {
    home: "Home",
    products: "Products",
    categories: "Categories",
    about: "About",
    contact: "Contact",
    rfqBasket: "RFQ Basket",
    rfqBasketShort: "RFQ",
    solutions: "Solutions",
    procurementModels: "Procurement Models",
    procurementModelsShort: "Procurement",
    headerLiveShipmentTracking: "Live Shipment Tracking",
    navSolutionGroupB2bSourcing: "B2B Sourcing",
    navSolutionGroupProcurementModel: "Procurement Model",
    navSolutionGroupDigitalFreight: "Digital Freight Execution",
    navSolutionGroupImportControlTower: "Import Control Tower",
    navSolutionRfq: "RFQ™",
    navSolutionCommodityBid: "CommodityBid™",
    navSolutionVerifiedManufacturers: "Verified Manufacturers™",
    navSolutionFreightIq: "FreightIQ™",
    navSolutionCarrierCoordination: "Carrier Coordination™",
    navSolutionFreightBooking: "Freight Booking™",
    navSolutionEstimatedCif: "Estimated CIF™",
    navSolutionBulkContainer: "Bulk Container™",
    navSolutionFullContainer: "Full Container™",
    navSolutionSmartContainer: "Smart Container™",
    navSolutionInspection: "Inspection™",
    navSolutionShipmentTracking: "Live Shipment Tracking™",
    navSolutionDocumentCenter: "Document Center™",
    navSolutionExceptionHub: "Exception Hub™",
    headerSearchPlaceholder: "Search for products",
    customerPanel: "Dashboard",
    heroSubtitle:
      "Access verified Turkish manufacturers, receive factory-direct quotations directly from manufacturer's sales teams, manage purchase order execution, compare freight offers, reduce sourcing risk with inspections, and monitor shipment visibility all in one platform.",
    heroSearch: "Search products, categories, or suppliers...",
    heroSearchBtn: "Search",
    heroCta: "Browse All Products",
    heroStats1: "Products",
    heroStats3: "Countries",
    browseCategories: "Browse by Category",
    categoriesSub: "Explore our wide range of product categories",
    viewAll: "View All",
    allProducts: "All Products",
    addToRfq: "Add to RFQ Basket",
    added: "Added!",
    minOrder: "Min. Order",
    origin: "Origin",
    requestQuote: "Request Quote",
    rfqTitle: "RFQ Basket",
    rfqEmpty: "Your RFQ basket is empty",
    rfqEmptySub: "Browse products and add items to request a quote",
    rfqSubmit: "Submit RFQ",
    rfqCompany: "Company Name",
    rfqEmail: "Email",
    rfqPhone: "Phone",
    rfqQuantity: "Qty",
    rfqSuccess: "RFQ Submitted Successfully!",
    rfqSuccessSub: "Our team will review your request and contact you within 24 hours.",
    liveChat: "Live Chat",
    liveChatSub: "How can we help you today?",
    chatPlaceholder: "Type your message...",
    chatWelcome: "Welcome! How can we assist you with your wholesale purchasing needs?",
    aiAssistant: "AI Trade Assistant",
    aiSub: "Ask about products, shipping, or customs",
    aiPlaceholder: "Ask about Turkish products...",
    aiWelcome: "Hello! I'm your AI trade assistant. I can help you with product information, shipping logistics, customs requirements, and more. How can I help?",
    footerDesc: "Your global gateway to quality Turkish products. Connecting international buyers with verified Turkish suppliers.",
    quickLinks: "Quick Links",
    productCategories: "Product Categories",
    contactUs: "Contact Us",
    allRights: "All rights reserved.",
    aboutTitle: "Global Trade, Turkish Quality",
    aboutDesc: "We connect international businesses with premium Turkish manufacturers and suppliers across food, cleaning, construction, and personal care sectors.",
    aboutDeMaxtoreHeading: "About DeMaxtore",
    aboutBody1:
      "DeMaxtore Inc was founded in 1999 as an international marketing and customer relationship management company.",
    aboutBody2:
      "Demaxtore.com is a comprehensive Business to Business platform that connects Turkish manufacturers and suppliers with global buyers from all over the world.",
    aboutBody3:
      "We have so many subscribed members ranking from the biggest and high-tech manufacturers to small suppliers. Demaxtore.com B2B platform provides service for international buyers to find best quality products with best possible prices in Turkey.",
    aboutBody4:
      "Search products you need and contact suppliers directly to get information on product technical details and price offers.",
    stat1Title: "Verified Products",
    stat2Title: "Export Countries",
    stat3Title: "Active Suppliers",
    stat4Title: "Completed Orders",
    panelTitle: "Customer Dashboard",
    panelRfqs: "My RFQs",
    panelProducts: "Saved Products",
    panelSettings: "Settings",
    panelTotalRfq: "Total RFQs",
    panelPending: "Pending",
    panelApproved: "Approved",
    panelVolume: "Trade Volume",
    contactTitle: "Get in Touch",
    contactSub: "Have questions? Send us a message",
    contactName: "Your Name",
    contactEmail: "Email Address",
    contactCompany: "Company Name",
    contactMessage: "Message",
    contactSend: "Send Message",
    contactSent: "Message Sent!",
    filterAll: "All Categories",
    noProducts: "No products found",
    noProductsSub: "Try adjusting your search or filter criteria",
    authAccountAria: "Account — sign in or register",
    authAccountMenu: "Sign in or register",
    authKicker: "B2B buyer portal",
    authAsideHeadline: "Your wholesale sourcing desk for Türkiye",
    authAside1: "RFQs reviewed by our trade team",
    authAside2: "Manufacturers vetted for export readiness",
    authAside3: "Support on pricing, specs, and documentation",
    authTitle: "Sign in or register",
    authSubtitle:
      "Use your company email to access your buyer workspace or open a new profile. Submit RFQs from the catalog anytime—our team follows up on every request, with or without an account.",
    authSignIn: "Sign in",
    authRegister: "Register",
    authEmail: "Email",
    authPassword: "Password",
    authConfirmPassword: "Confirm password",
    authCompany: "Company (optional)",
    authSubmitSignIn: "Sign in",
    authSubmitRegister: "Create account",
    authBackHome: "Back to home",
    authEmailPlaceholder: "you@company.com",
    authPasswordPlaceholder: "Enter your password",
    authSuccessNotice:
      "Thank you—we have received your request. Our trade desk will contact you shortly to finalize access. In the meantime, continue browsing and use the RFQ basket as usual.",
    authFillRequired: "Please enter email and password.",
    authPasswordMismatch: "Passwords do not match.",
    authNeedHelp: "Need help?",
    authContactLink: "Contact us",
    authLayoutSignInHeading: "Sign in",
    authLayoutDontHave: "Don't have an account?",
    authSignUpLink: "Sign up",
    authDemoDivider: "Or try a demo role",
    authDemoBadge: "1-click demo",
    authDemoShipper: "Shipper",
    authDemoForwarder: "Forwarder",
    authDemoAdmin: "Admin",
    authDemoNotConfigured:
      "This demo shortcut is not configured. Add credentials to the site environment, or sign in manually.",
    accountForgotPassword: "Forgot password? Contact us",
    accountSigningIn: "Signing in…",
    accountCreating: "Creating account…",
    accountLoginFailed: "Sign-in failed.",
    accountRegisterFailed: "Could not create account.",
    accountPasswordMin: "Password must be at least 8 characters.",
    accountMyRfqsTitle: "Your submitted RFQs",
    accountMyRfqsDesc:
      "Quotes appear here when the RFQ contact email matches this account — use the same email on the RFQ form.",
    accountSignOut: "Sign out",
    accountLoadingRfqs: "Loading…",
    accountNoRfqsYet: "No RFQs yet. Open the RFQ basket and submit a quote with your account email.",
    blog: "Blog",
    blogPageTitle: "Trade insights",
    blogPageSubtitle:
      "Short notes on wholesale sourcing, RFQs, and working with verified Turkish suppliers.",
    blog_post1_title: "Get more accurate quotes from your RFQ",
    blog_post1_meta: "March 2025",
    blog_post1_excerpt:
      "State clear quantities, packaging, destination port, and target delivery window. Suppliers respond faster when requirements are concrete, and you avoid back-and-forth on basics.",
    blog_post2_title: "Why buyers source FMCG and building materials from Turkey",
    blog_post2_meta: "January 2025",
    blog_post2_excerpt:
      "Scale manufacturing, competitive bulk pricing, and experience with export documentation make Turkey a practical hub for categories from food to construction consumables.",
    blog_post3_title: "Before your first shipment: simple supplier checks",
    blog_post3_meta: "November 2024",
    blog_post3_excerpt:
      "Ask for references in your region, confirm certifications relevant to your market, and agree on sampling or specifications in writing. A few clear steps reduce risk on early orders.",
    blogCtaTitle: "Ready to request a quote?",
    blogCtaSub: "Browse the catalog or add lines to your RFQ basket — our team follows up on every submission.",
    blog_hero_kicker: "Insights for wholesale buyers",
    blog_featured: "Featured",
    blog_tag_rfq: "RFQ & quotes",
    blog_tag_markets: "Markets & Turkey",
    blog_tag_quality: "Risk & quality",
    blog_est_read: "About 3 min read",
    blogReadArticle: "Read article",
    blogBackToList: "All articles",
    wishlist: "Wishlist",
    wishlistAria: "Wishlist — saved products",
    wishlistPageTitle: "Your wishlist",
    wishlistPageSubtitle: "Products you saved with the heart icon appear here.",
    wishlistEmptyTitle: "Your wishlist is empty",
    wishlistEmptySub: "Browse the catalog and tap the heart on any product to save it here.",
    wishlistLoading: "Loading your saved products…",
    wishlistBrowseCta: "Browse products",
    inspectionDocs: "Quality documents",
    inspectionChecklist: "Inspection Checklist",
    inspectionReport: "Inspection Report",
    freightIqLogoAlt: "FreightIQ — Smart freight decisions",
    freightIqLivePill: "Live freight rates",
    freightIqHeadlineLead: "Smart freight decisions,",
    freightIqHeadlineAccent: "all in one place.",
    freightIqDescription:
      "Compare freight price offers from {count} forwarders. Evaluate transit times and costs, and select the best option with confidence.",
    freightIqDescriptionCount: "500+",
    freightTrustCarriers: "500+ forwarders",
    freightTrustCountries: "120+ countries",
    freightTrustForwarders: "Verified forwarders",
    freightDeparturePort: "Departure Port",
    freightDestinationPort: "Destination Port",
    freightCargoDetails: "Cargo Details",
    freightCargoType: "Cargo Type",
    freightPhCityPort: "Enter city or port",
    freightPhCargoDetails: "Enter cargo details",
    freightPhCargoType: "Describe your goods",
    freightLoadingInterval: "Estimated loading interval",
    freightDateFrom: "From",
    freightDateTo: "To",
    freightDateFromAria: "From date",
    freightDateToAria: "To date",
    freightSearchAria: "Search freight",
    freightSubmitQuoteAria: "Submit freight quote request",
    freightInquiry: "Freight Inquiry",
    freightSearch: "Search",
    freightSubmitCta: "Request quote",
    freightRequesterEmail: "Your email",
    freightPhRequesterEmail: "name@company.com",
    freightSubmitting: "Sending…",
    freightSentThanks: "We received your inquiry and notified forwarders.",
    freightSubmitError: "Could not send. Please try again in a moment.",
    freightFillRequired: "Please fill all fields, including your email.",
    freightQuoteSentTitle: "Your quote request was sent",
    freightQuoteSentSub:
      "Your request was saved and forwarded to the relevant parties. You will receive quotes as notifications.",
    freightTrackKicker: "SHIPMENT VISIBILITY",
    freightTrackTitleA: "Real-time shipment visibility with",
    freightTrackTitleB: "ETA intelligence",
    freightTrackSub:
      "Track your ocean shipments from departure port to arrival port with real-time visibility, ETA monitoring, and proactive delay alerts. Stay informed at every milestone and plan with greater confidence.",
    freightTrackFeature1Title: "Real-Time Visibility",
    freightTrackFeature1Desc: "Track your vessel and shipment progress on a live map.",
    freightTrackFeature2Title: "ETA Monitoring",
    freightTrackFeature2Desc: "Stay updated with estimated arrival changes in real time.",
    freightTrackFeature3Title: "Delay Alerts",
    freightTrackFeature3Desc: "Receive proactive notifications for delays and transit disruptions.",
    freightTrackFeature4Title: "Shipment Milestones",
    freightTrackFeature4Desc: "Monitor every key milestone from departure to port arrival.",
    freightTrackCta: "Track your shipment",
    freightTrackEtaLabel: "Estimated arrival",
    freightTrackEtaSub: "3 days left",
    freightTrackLocLabel: "Current location",
    freightTrackLocValue: "North of Suez Canal",
    freightTrackLocBadge: "Vessel in transit",
    freightTrackVesselLabel: "Vessel",
    freightTrackVesselName: "MSC AURORA",
    freightTrackVesselType: "Containership",
    freightTrackNextPortLabel: "Next port",
    freightTrackNextPortValue: "Jebel Ali, UAE",
    freightTrackNextEtaPrefix: "ETA:",
    freightTrackStepDeparted: "Departed (May 10)",
    freightTrackStepTransit: "In transit",
    freightTrackStepOnWay: "On the way",
    freightTrackStepArriving: "Arriving soon",
    freightTrackMapAlt: "Global shipping route map illustration",
    freightTrackLogoAlt: "DeMaxtore Live Shipment Tracking",
    inspectionShowLogoAlt: "DeMaxtore Inspection",
    inspectionShowKicker: "Inspection & verification",
    inspectionShowTitleA: "Verify your products",
    inspectionShowTitleB1: "before they",
    inspectionShowTitleB2: "ship",
    inspectionShowSub: "Reduce risk, ensure quality, and ship with confidence.",
    inspectionShowHeroAlt: "Inspector at a shipping container with checklist",
    inspectionShowFeat1Title: "Quality inspection",
    inspectionShowFeat1Desc: "Independent inspection before shipment.",
    inspectionShowFeat2Title: "Photo & video reports",
    inspectionShowFeat2Desc: "See exactly what is being shipped.",
    inspectionShowFeat3Title: "Detailed inspection reports",
    inspectionShowFeat3Desc: "Clear documentation of product condition.",
    inspectionShowFeat4Title: "Risk reduction",
    inspectionShowFeat4Desc: "Identify issues before they become costly problems.",
    inspectionShowTrust1: "Independent & reliable inspections",
    inspectionShowTrust2: "Trusted by global importers",
    inspectionShowChecklistTitle: "Inspection Checklist",
    inspectionShowCheckPackaging: "Packaging condition",
    inspectionShowCheckQty: "Product quantity",
    inspectionShowCheckQuality: "Product quality",
    inspectionShowCheckLabel: "Label & marking",
    inspectionShowCheckCarton: "Carton damage",
    inspectionShowStatusOk: "OK",
    inspectionShowStatusMinor: "Minor",
    inspectionShowCompletedBar: "Inspection Completed",
    inspectionShowCompletedWhen: "May 18, 2025 • 10:30 AM",
    inspectionShowThumbPackaging: "Packaging",
    inspectionShowThumbQuantity: "Quantity",
    inspectionShowThumbQuality: "Quality check",
    inspectionShowThumbLabel: "Label & marking",
    inspectionShowThumbReport: "Report",
    smartSourceAria:
      "CommodityBid — FEATURE POINTS. Smarter sourcing. Better prices. Stronger decisions.",
    smartSourceBadge: "Price Driven. Value Delivered.",
    smartSourceTitleLine1: "Smarter Sourcing.",
    smartSourceTitleLine2: "Better Prices.",
    smartSourceSubtitle:
      "Smarter sourcing.\nBetter prices.\nStronger decisions.",
    smartSourceFeat1Title: "Market-based pricing",
    smartSourceFeat1Desc: "Access competitive offers aligned with current market conditions.",
    smartSourceFeat2Title: "Structured comparison",
    smartSourceFeat2Desc: "Review multiple supplier quotes in one clear view.",
    smartSourceFeat3Title: "Faster decision-making",
    smartSourceFeat3Desc: "Receive and evaluate offers without delays.",
    smartSourceFeat4Title: "The lowest market prices",
    smartSourceFeat4Desc: "Compare offers and secure competitive market pricing.",
    smartSourceCardBest: "Best Price",
    smartSourceCardPrice: "$1,245",
    smartSourceCardUnit: "/MT",
    smartSourceCardDelta: "+4.2% vs last week",
    smartSourceCardTrend: "Market Trend",
    smartSourceCardTrendPct: "+4.2%",
    smartSourceMicroLbl: "Micro Value",
    smartSourceMicroDesc: "Built for price-driven commodity sourcing.",
    smartSourcePhotoAlt: "Shipping containers at port at dusk",
    smartBentoHeroTitle1: "FEATURE",
    smartBentoHeroTitle2: "POINTS",
    smartBentoHeroLine1: "Smarter sourcing.",
    smartBentoHeroLine2: "Better prices.",
    smartBentoHeroLine3: "Stronger decisions.",
    smartBentoHeroLogoAlt: "CommodityBid — Find the best price",
    smartBentoFeatureHeroParagraph:
      "Access competitive offers, compare\nmultiple suppliers, and make faster\nsmarter sourcing decisions.",
    smartBentoMicroLine1: "Built for price-driven",
    smartBentoMicroLine2: "commodity sourcing.",
    smartBentoImgContainersAlt: "Stacked shipping containers",
    smartBentoImgGlobeAlt: "Globe with trade network",
    smartBentoImgMagnifierAlt: "Charts and analytics",
    smartBentoImgLaptopAlt: "Dashboard on laptop",
    smartBentoImgTimerAlt: "Stopwatch",
    smartBentoImgChartAlt: "Price chart",
    smartBentoImgCargoAlt: "Cargo ship at port",
    smartBentoCreateBid: "Create a bid",
    smartBentoCard3Title: "GLOBAL COMMODITY ACCESS",
    smartBentoCard3Desc:
      "Commodity markets move fast. Collect multiple supplier offers in a structured way and identify the best available price — quickly and clearly.",
    smartBentoFooter1: "COMPETITIVE PRICING",
    smartBentoFooter2: "TRUSTED SUPPLIERS",
    smartBentoFooter3: "DATA-DRIVEN INSIGHTS",
    smartBentoFooter4: "FAST & EFFICIENT",
    cookieBannerBefore:
      "We use cookies to improve the experience and for anonymous usage statistics. For details see our",
    cookieBannerLink: "Cookie Policy",
    cookieBannerAfter: "page.",
    cookieAccept: "Accept cookies",
    cookieBannerAria: "Cookie notice",
    productVerifiedSupplier: "Verified Supplier",
    footerCategoryUncategorized: "Uncategorized",
    footerLinkWebsitePrivacy: "Website Privacy Notice",
    footerLinkPrivacy: "Privacy Policy",
    footerLinkCookies: "Cookie Policy",
    footerLogoAlt: "DeMaxtore — Connecting Buyers with Turkish Suppliers",
    highlightLabelProductQuality: "Product Quality",
    highlightLabelProductSizes: "Product Sizes",
    highlightLabelPackageSizes: "Package Sizes",
    highlightLabelPackageQuantitiesCarton: "Package Quantities in Carton",
    highlightLabelShelfLife: "Shelf Life",
    highlightLabelPrivateLabel: "Private Label Production",
    highlightLabelPrivateLabelShort: "Private Label",
    highlightLabelNetWeight: "Net Weight",
    highlightLabelStorage: "Storage",
    highlightLabelIngredients: "Ingredients",
    highlightLabelCertification: "Certification",
    highlightValueAvailable: "Available",
    highlightValueNotAvailable: "Not available",
    highlightValueYes: "Yes",
    highlightValueNo: "No",
  },
  fr: {
    home: "Accueil",
    products: "Produits",
    categories: "Catégories",
    about: "À propos",
    contact: "Contact",
    rfqBasket: "Panier RFQ",
    rfqBasketShort: "RFQ",
    solutions: "Services",
    procurementModels: "Modèles d'approvisionnement",
    procurementModelsShort: "Approvisionnement",
    headerLiveShipmentTracking: "Suivi d'expédition en direct",
    navSolutionGroupB2bSourcing: "Approvisionnement B2B",
    navSolutionGroupProcurementModel: "Modèle d'approvisionnement",
    navSolutionGroupDigitalFreight: "Exécution fret numérique",
    navSolutionGroupImportControlTower: "Tour de contrôle import",
    navSolutionRfq: "RFQ™",
    navSolutionCommodityBid: "CommodityBid™",
    navSolutionVerifiedManufacturers: "Fabricants vérifiés™",
    navSolutionFreightIq: "FreightIQ™",
    navSolutionCarrierCoordination: "Coordination transporteurs™",
    navSolutionFreightBooking: "Réservation fret™",
    navSolutionEstimatedCif: "CIF estimé™",
    navSolutionBulkContainer: "Conteneur vrac™",
    navSolutionFullContainer: "Conteneur complet™",
    navSolutionSmartContainer: "Conteneur intelligent™",
    navSolutionInspection: "Inspection™",
    navSolutionShipmentTracking: "Suivi d'expédition en direct™",
    navSolutionDocumentCenter: "Centre documentaire™",
    navSolutionExceptionHub: "Hub exceptions™",
    headerSearchPlaceholder: "Rechercher des produits",
    customerPanel: "Tableau de bord",
    heroSubtitle:
      "Accédez à des fabricants Turcs qualifiés, recevez des devis directement auprès de leurs équipes commerciales, gérez l'exécution des bons de commande, comparez les offres de fret, sécurisez votre approvisionnement grâce aux contrôles qualité avant expédition et bénéficiez d'une visibilité en temps réel sur vos expéditions. Le tout sur une plateforme unique. ",
    heroSearch: "Rechercher des produits, catégories ou fournisseurs…",
    heroSearchBtn: "Rechercher",
    heroCta: "Voir tous les produits",
    heroStats1: "Produits",
    heroStats3: "Pays",
    browseCategories: "Parcourir par catégorie",
    categoriesSub: "Explorez notre large gamme de catégories de produits",
    viewAll: "Voir tout",
    allProducts: "Tous les produits",
    addToRfq: "Ajouter au panier RFQ",
    added: "Ajouté !",
    minOrder: "Commande min.",
    origin: "Origine",
    requestQuote: "Demander un devis",
    rfqTitle: "Panier RFQ",
    rfqEmpty: "Votre panier RFQ est vide",
    rfqEmptySub: "Parcourez les produits et ajoutez des articles pour demander un devis",
    rfqSubmit: "Envoyer la demande",
    rfqCompany: "Nom de l'entreprise",
    rfqEmail: "E-mail",
    rfqPhone: "Téléphone",
    rfqQuantity: "Qté",
    rfqSuccess: "Demande envoyée avec succès !",
    rfqSuccessSub: "Notre équipe examinera votre demande et vous contactera sous 24 heures.",
    liveChat: "Chat en direct",
    liveChatSub: "Comment pouvons-nous vous aider aujourd'hui ?",
    chatPlaceholder: "Tapez votre message...",
    chatWelcome: "Bienvenue ! Comment pouvons-nous vous aider pour vos achats en gros ?",
    aiAssistant: "Assistant IA Commerce",
    aiSub: "Posez des questions sur les produits, l’expédition ou la douane",
    aiPlaceholder: "Posez une question sur les produits turcs...",
    aiWelcome: "Bonjour ! Je suis votre assistant IA commerce. Je peux vous aider concernant les produits, la logistique et la douane. Comment puis-je vous aider ?",
    footerDesc:
      "Votre passerelle mondiale vers des produits turcs de qualité. Nous connectons les acheteurs internationaux avec des fournisseurs vérifiés.",
    quickLinks: "Liens rapides",
    productCategories: "Catégories de produits",
    contactUs: "Contactez-nous",
    allRights: "Tous droits réservés.",
    aboutTitle: "Commerce mondial, qualité turque",
    aboutDesc: "Nous mettons en relation les entreprises internationales avec des fabricants et fournisseurs turcs premium.",
    aboutDeMaxtoreHeading: "À propos de DeMaxtore",
    aboutBody1:
      "Fondée en 1999, DeMaxtore Inc. est une société internationale spécialisée dans le marketing et la gestion de la relation client.",
    aboutBody2:
      "Demaxtore.com est une plateforme B2B qui connecte les fabricants et fournisseurs turcs aux acheteurs internationaux à travers le monde.",
    aboutBody3:
      "Elle rassemble un réseau diversifié de partenaires, allant des grands industriels de haute technologie aux fournisseurs spécialisés.",
    aboutBody4:
      "La plateforme permet aux acheteurs de trouver des produits de qualité à des prix compétitifs en Turquie et de contacter directement les fournisseurs pour obtenir des informations techniques et des offres de prix.",
    stat1Title: "Produits vérifiés",
    stat2Title: "Pays d'exportation",
    stat3Title: "Fournisseurs actifs",
    stat4Title: "Commandes terminées",
    panelTitle: "Tableau de bord client",
    panelRfqs: "Mes RFQ",
    panelProducts: "Produits enregistrés",
    panelSettings: "Paramètres",
    panelTotalRfq: "RFQ totaux",
    panelPending: "En attente",
    panelApproved: "Approuve",
    panelVolume: "Volume commercial",
    contactTitle: "Contactez-nous",
    contactSub: "Vous avez des questions ? Envoyez-nous un message",
    contactName: "Votre nom",
    contactEmail: "Adresse e-mail",
    contactCompany: "Nom de l'entreprise",
    contactMessage: "Message",
    contactSend: "Envoyer le message",
    contactSent: "Message envoyé !",
    filterAll: "Toutes les catégories",
    noProducts: "Aucun produit trouvé",
    noProductsSub: "Essayez d'ajuster votre recherche ou vos filtres",
    authAccountAria: "Compte — connexion ou inscription",
    authAccountMenu: "Connexion ou inscription",
    authKicker: "Portail acheteur B2B",
    authAsideHeadline: "Votre interlocuteur pour l'achat en gros depuis la Turquie",
    authAside1: "RFQ traitées par notre équipe commerciale",
    authAside2: "Fabricants vérifiés pour l'export",
    authAside3: "Accompagnement sur prix, spécifications et documentation",
    authTitle: "Connexion ou inscription",
    authSubtitle:
      "Utilisez l'e-mail professionnel de votre entreprise pour accéder à votre espace acheteur ou ouvrir un nouveau profil. Envoyez des RFQ depuis le catalogue à tout moment — notre équipe donne suite à chaque demande, avec ou sans compte.",
    authSignIn: "Connexion",
    authRegister: "Inscription",
    authEmail: "E-mail",
    authPassword: "Mot de passe",
    authConfirmPassword: "Confirmer le mot de passe",
    authCompany: "Entreprise (facultatif)",
    authSubmitSignIn: "Se connecter",
    authSubmitRegister: "Créer le compte",
    authBackHome: "Retour à l'accueil",
    authEmailPlaceholder: "vous@entreprise.com",
    authPasswordPlaceholder: "Saisissez votre mot de passe",
    authSuccessNotice:
      "Merci — nous avons bien reçu votre demande. Notre équipe commerciale vous contactera rapidement pour finaliser l'accès. En attendant, poursuivez la navigation et utilisez le panier RFQ comme d'habitude.",
    authFillRequired: "Veuillez saisir l'e-mail et le mot de passe.",
    authPasswordMismatch: "Les mots de passe ne correspondent pas.",
    authNeedHelp: "Besoin d'aide ?",
    authContactLink: "Nous contacter",
    authDemoDivider: "Ou essayez un rôle démo",
    authDemoBadge: "Démo en 1 clic",
    authDemoShipper: "Expéditeur",
    authDemoForwarder: "Transitaire",
    authDemoAdmin: "Administrateur",
    authDemoNotConfigured:
      "Ce raccourci démo n’est pas configuré. Ajoutez les identifiants dans l’environnement du site, ou connectez-vous manuellement.",
    authLayoutSignInHeading: "Connexion",
    authLayoutDontHave: "Vous n'avez pas de compte ?",
    authSignUpLink: "S'inscrire",
    accountForgotPassword: "Mot de passe oublié ? Contactez-nous",
    accountSigningIn: "Connexion en cours…",
    accountCreating: "Création du compte…",
    accountLoginFailed: "Échec de la connexion.",
    accountRegisterFailed: "Impossible de créer le compte.",
    accountPasswordMin: "Le mot de passe doit comporter au moins 8 caractères.",
    accountMyRfqsTitle: "Vos demandes de devis envoyées",
    accountMyRfqsDesc:
      "Les devis apparaissent ici lorsque l'e-mail RFQ correspond à ce compte — utilisez le même e-mail sur le formulaire RFQ.",
    accountSignOut: "Déconnexion",
    accountLoadingRfqs: "Chargement…",
    accountNoRfqsYet:
      "Aucune RFQ pour le moment. Ouvrez le panier RFQ et envoyez une demande avec l'e-mail de votre compte.",
    blog: "Blog",
    blogPageTitle: "Actualites commerce",
    blogPageSubtitle:
      "Notes courtes sur l’approvisionnement de gros, les RFQ et le travail avec des fournisseurs turcs vérifiés.",
    blog_post1_title: "Obtenir des devis plus précis avec votre RFQ",
    blog_post1_meta: "mars 2025",
    blog_post1_excerpt:
      "Indiquez quantités, conditionnement, port de destination et délai souhaité. Les fournisseurs répondent plus vite lorsque les besoins sont concrets, ce qui limite les allers-retours.",
    blog_post2_title: "Pourquoi les acheteurs sourcent FMCG et matériaux en Turquie",
    blog_post2_meta: "janvier 2025",
    blog_post2_excerpt:
      "Fabrication à grande échelle, prix de gros compétitifs et expérience des formalités d’export font de la Turquie un hub pratique, de l’alimentaire aux consommables du bâtiment.",
    blog_post3_title: "Avant le premier envoi : vérifications fournisseur simples",
    blog_post3_meta: "novembre 2024",
    blog_post3_excerpt:
      "Demandez des références dans votre région, confirmez les certifications utiles pour votre marché et fixez par écrit échantillons ou spécifications. Quelques étapes claires réduisent le risque.",
    blogCtaTitle: "Prêt à demander un devis ?",
    blogCtaSub: "Parcourez le catalogue ou ajoutez des lignes au panier RFQ — notre équipe répond à chaque demande.",
    blog_hero_kicker: "Conseils pour acheteurs de gros",
    blog_featured: "A la une",
    blog_tag_rfq: "RFQ & devis",
    blog_tag_markets: "Marchés & Turquie",
    blog_tag_quality: "Risque & qualite",
    blog_est_read: "Env. 3 min de lecture",
    blogReadArticle: "Lire l'article",
    blogBackToList: "Tous les articles",
    wishlist: "Liste de souhaits",
    wishlistAria: "Liste de souhaits — produits enregistres",
    wishlistPageTitle: "Votre liste de souhaits",
    wishlistPageSubtitle: "Les produits enregistrés avec l’icône cœur s’affichent ici.",
    wishlistEmptyTitle: "Votre liste est vide",
    wishlistEmptySub: "Parcourez le catalogue et touchez le coeur sur un produit pour lenregistrer ici.",
    wishlistLoading: "Chargement de vos produits enregistres…",
    wishlistBrowseCta: "Voir les produits",
    inspectionDocs: "Documents qualité",
    inspectionChecklist: "Liste de contrôle",
    inspectionReport: "Rapport d'inspection",
    freightIqLogoAlt: "FreightIQ — Décisions fret intelligentes",
    freightIqLivePill: "Tarifs fret en direct",
    freightIqHeadlineLead: "Des décisions de fret intelligentes,",
    freightIqHeadlineAccent: "réunies en un seul endroit.",
    freightIqDescription:
      "Comparez les offres de fret de plus de {count} transitaires. Évaluez les délais et les coûts, puis choisissez la meilleure option en toute confiance.",
    freightIqDescriptionCount: "500+",
    freightTrustCarriers: "500+ transitaires",
    freightTrustCountries: "120+ pays",
    freightTrustForwarders: "Transitaires vérifiés",
    freightDeparturePort: "Port de départ",
    freightDestinationPort: "Port de destination",
    freightCargoDetails: "Détails de la cargaison",
    freightCargoType: "Type de cargaison",
    freightPhCityPort: "Ville ou port",
    freightPhCargoDetails: "Détails de la cargaison",
    freightPhCargoType: "Décrivez votre marchandise",
    freightLoadingInterval: "Intervalle de chargement estimé",
    freightDateFrom: "Du",
    freightDateTo: "Au",
    freightDateFromAria: "Date de début",
    freightDateToAria: "Date de fin",
    freightSearchAria: "Rechercher le fret",
    freightSubmitQuoteAria: "Envoyer la demande de cotation fret",
    freightInquiry: "Demande de fret",
    freightSearch: "Rechercher",
    freightSubmitCta: "Demander un devis",
    freightRequesterEmail: "Votre e-mail",
    freightPhRequesterEmail: "nom@entreprise.com",
    freightSubmitting: "Envoi en cours…",
    freightSentThanks: "Nous avons bien reçu votre demande et avons informé les transitaires.",
    freightSubmitError: "Envoi impossible. Veuillez réessayer dans un instant.",
    freightFillRequired: "Veuillez remplir tous les champs, y compris votre e-mail.",
    freightQuoteSentTitle: "Votre demande a bien été envoyée",
    freightQuoteSentSub:
      "Elle a été enregistrée et transmise aux personnes concernées. Vous recevrez les devis sous forme de notifications.",
    freightTrackKicker: "VISIBILITÉ DES EXPÉDITIONS",
    freightTrackTitleA: "Visibilité maritime en temps réel et",
    freightTrackTitleB: "ETA intelligente",
    freightTrackSub:
      "Suivez vos expéditions maritimes de bout en bout, du port de départ au port d'arrivée, avec une visibilité en temps réel, des ETA précises et des alertes de retard. Restez informé à chaque étape et planifiez en toute confiance.",
    freightTrackFeature1Title: "Visibilité en temps réel",
    freightTrackFeature1Desc: "Suivez votre navire et l'avancement de l'expédition sur une carte live.",
    freightTrackFeature2Title: "Suivi ETA",
    freightTrackFeature2Desc: "Restez informé des changements d'arrivée estimée en temps réel.",
    freightTrackFeature3Title: "Alertes retard",
    freightTrackFeature3Desc: "Recevez des notifications proactives en cas de retard ou de perturbation en transit.",
    freightTrackFeature4Title: "Jalons d'expédition",
    freightTrackFeature4Desc: "Surveillez chaque jalon clé du départ à l'arrivée au port.",
    freightTrackCta: "Suivre votre expédition",
    freightTrackEtaLabel: "Arrivée estimée",
    freightTrackEtaSub: "Encore 3 jours",
    freightTrackLocLabel: "Position actuelle",
    freightTrackLocValue: "Au nord du canal de Suez",
    freightTrackLocBadge: "Navire en route",
    freightTrackVesselLabel: "Navire",
    freightTrackVesselName: "MSC AURORA",
    freightTrackVesselType: "Porte-conteneurs",
    freightTrackNextPortLabel: "Prochain port",
    freightTrackNextPortValue: "Jebel Ali, EAU",
    freightTrackNextEtaPrefix: "ETA :",
    freightTrackStepDeparted: "Parti (10 mai)",
    freightTrackStepTransit: "En transit",
    freightTrackStepOnWay: "En route",
    freightTrackStepArriving: "Bientôt l'arrivée",
    freightTrackMapAlt: "Illustration : route maritime en Méditerranée",
    freightTrackLogoAlt: "DeMaxtore — Suivi d'expédition en direct",
    inspectionShowLogoAlt: "DeMaxtore Inspection",
    inspectionShowKicker: "Inspection et vérification",
    inspectionShowTitleA: "Vérifiez vos produits",
    inspectionShowTitleB1: "avant",
    inspectionShowTitleB2: "l'expédition",
    inspectionShowSub:
      "Réduisez les risques, garantissez la qualité et expédiez en toute confiance.",
    inspectionShowHeroAlt: "Inspecteur devant un conteneur avec liste de contrôle",
    inspectionShowFeat1Title: "Contrôle qualité",
    inspectionShowFeat1Desc: "Inspection indépendante avant chargement.",
    inspectionShowFeat2Title: "Rapports photo et vidéo",
    inspectionShowFeat2Desc: "Visualisez exactement ce qui sera expédié.",
    inspectionShowFeat3Title: "Rapports d'inspection détaillés",
    inspectionShowFeat3Desc: "Documentation claire de l'état des produits.",
    inspectionShowFeat4Title: "Réduction des risques",
    inspectionShowFeat4Desc: "Identification des problèmes.",
    inspectionShowTrust1: "Inspections indépendantes et fiables",
    inspectionShowTrust2: "Reconnu par les importateurs du monde entier.",
    inspectionShowChecklistTitle: "Liste d'inspection",
    inspectionShowCheckPackaging: "État de l'emballage",
    inspectionShowCheckQty: "Quantité produit",
    inspectionShowCheckQuality: "Qualité produit",
    inspectionShowCheckLabel: "Étiquetage et marquage",
    inspectionShowCheckCarton: "Dommage carton",
    inspectionShowStatusOk: "OK",
    inspectionShowStatusMinor: "Mineur",
    inspectionShowCompletedBar: "Inspection terminée",
    inspectionShowCompletedWhen: "18 mai 2025 • 10:30",
    inspectionShowThumbPackaging: "Emballage",
    inspectionShowThumbQuantity: "Quantité",
    inspectionShowThumbQuality: "Contrôle qualité",
    inspectionShowThumbLabel: "Étiquette et marquage",
    inspectionShowThumbReport: "Rapport",
    smartSourceAria:
      "CommodityBid — FEATURE POINTS. Sourcing plus intelligent. De meilleurs prix. Des décisions plus solides.",
    smartSourceBadge: "Prix au centre. Valeur livrée.",
    smartSourceTitleLine1: "Sourcing plus intelligent.",
    smartSourceTitleLine2: "De meilleurs prix.",
    smartSourceSubtitle:
      "Sourcing plus intelligent.\nDe meilleurs prix.\nDes décisions plus solides.",
    smartSourceFeat1Title: "Tarification basée sur le marché",
    smartSourceFeat1Desc: "Accédez à des offres compétitives alignées sur les conditions actuelles du marché.",
    smartSourceFeat2Title: "Comparaison structurée",
    smartSourceFeat2Desc: "Consultez plusieurs devis fournisseurs dans une vue claire.",
    smartSourceFeat3Title: "Prise de décision plus rapide",
    smartSourceFeat3Desc: "Recevez et évaluez les offres sans délais inutiles.",
    smartSourceFeat4Title: "Les prix les plus bas du marché",
    smartSourceFeat4Desc: "Comparez les offres et obtenez des prix de marché compétitifs.",
    smartSourceCardBest: "Meilleur prix",
    smartSourceCardPrice: "1 245 $",
    smartSourceCardUnit: "/t",
    smartSourceCardDelta: "+4,2 % vs semaine dernière",
    smartSourceCardTrend: "Tendance marché",
    smartSourceCardTrendPct: "+4,2 %",
    smartSourceMicroLbl: "Micro valeur",
    smartSourceMicroDesc: "Conçu pour le sourcing de matières premières piloté par le prix.",
    smartSourcePhotoAlt: "Conteneurs au port au crépuscule",
    smartBentoHeroTitle1: "FEATURE",
    smartBentoHeroTitle2: "POINTS",
    smartBentoHeroLine1: "Sourcing plus intelligent.",
    smartBentoHeroLine2: "De meilleurs prix.",
    smartBentoHeroLine3: "Des décisions plus solides.",
    smartBentoHeroLogoAlt: "CommodityBid — Trouvez le meilleur prix",
    smartBentoFeatureHeroParagraph:
      "Accédez à des offres compétitives, comparez\nplusieurs fournisseurs et prenez plus vite\ndes décisions d'approvisionnement plus éclairées.",
    smartBentoMicroLine1: "Conçu pour le sourcing",
    smartBentoMicroLine2: "de matières premières piloté par le prix.",
    smartBentoImgContainersAlt: "Conteneurs empilés",
    smartBentoImgGlobeAlt: "Réseau commercial mondial",
    smartBentoImgMagnifierAlt: "Graphiques et analyses",
    smartBentoImgLaptopAlt: "Tableau de bord sur ordinateur portable",
    smartBentoImgTimerAlt: "Chronomètre",
    smartBentoImgChartAlt: "Graphique de prix",
    smartBentoImgCargoAlt: "Cargo au port",
    smartBentoCreateBid: "Créer une offre",
    smartBentoCard3Title: "ACCÈS MONDIAL AUX MATIÈRES PREMIÈRES",
    smartBentoCard3Desc:
      "Les marchés évoluent vite. Rassemblez plusieurs offres fournisseurs de façon structurée et identifiez le meilleur prix disponible — vite et clairement.",
    smartBentoFooter1: "PRIX COMPÉTITIFS",
    smartBentoFooter2: "FOURNISSEURS DE CONFIANCE",
    smartBentoFooter3: "ANALYSES BASÉES SUR LES DONNÉES",
    smartBentoFooter4: "RAPIDE ET EFFICACE",
    cookieBannerBefore:
      "Nous utilisons des cookies pour améliorer l’expérience et pour des statistiques d’utilisation anonymes. Pour plus de détails, consultez notre",
    cookieBannerLink: "Politique des cookies",
    cookieBannerAfter: ".",
    cookieAccept: "Accepter les cookies",
    cookieBannerAria: "Avis sur les cookies",
    productVerifiedSupplier: "Fournisseur vérifié",
    footerCategoryUncategorized: "Non classé",
    footerLinkWebsitePrivacy: "Avis de confidentialité du site",
    footerLinkPrivacy: "Politique de confidentialité",
    footerLinkCookies: "Politique des cookies",
    footerLogoAlt: "DeMaxtore — Met en relation acheteurs et fournisseurs turcs",
    highlightLabelProductQuality: "Qualité du produit",
    highlightLabelProductSizes: "Formats produit",
    highlightLabelPackageSizes: "Formats / conditionnements",
    highlightLabelPackageQuantitiesCarton: "Quantités par carton",
    highlightLabelShelfLife: "Durée de conservation",
    highlightLabelPrivateLabel: "Production en marque propre",
    highlightLabelPrivateLabelShort: "Marque blanche",
    highlightLabelNetWeight: "Poids net",
    highlightLabelStorage: "Stockage",
    highlightLabelIngredients: "Ingrédients",
    highlightLabelCertification: "Certification",
    highlightValueAvailable: "Disponible",
    highlightValueNotAvailable: "Non disponible",
    highlightValueYes: "Oui",
    highlightValueNo: "Non",
  },
  es: {
    home: "Inicio",
    products: "Productos",
    categories: "Categorías",
    about: "Nosotros",
    contact: "Contacto",
    rfqBasket: "Cesta RFQ",
    rfqBasketShort: "RFQ",
    solutions: "Soluciones",
    procurementModels: "Modelos de abastecimiento",
    procurementModelsShort: "Abastecimiento",
    headerLiveShipmentTracking: "Seguimiento de envíos en vivo",
    navSolutionGroupB2bSourcing: "Abastecimiento B2B",
    navSolutionGroupProcurementModel: "Modelo de abastecimiento",
    navSolutionGroupDigitalFreight: "Ejecución de flete digital",
    navSolutionGroupImportControlTower: "Torre de control de importación",
    navSolutionRfq: "RFQ™",
    navSolutionCommodityBid: "CommodityBid™",
    navSolutionVerifiedManufacturers: "Fabricantes verificados™",
    navSolutionFreightIq: "FreightIQ™",
    navSolutionCarrierCoordination: "Coordinación de transportistas™",
    navSolutionFreightBooking: "Reserva de flete™",
    navSolutionEstimatedCif: "CIF estimado™",
    navSolutionBulkContainer: "Contenedor a granel™",
    navSolutionFullContainer: "Contenedor completo™",
    navSolutionSmartContainer: "Contenedor inteligente™",
    navSolutionInspection: "Inspección™",
    navSolutionShipmentTracking: "Seguimiento de envíos en vivo™",
    navSolutionDocumentCenter: "Centro documental™",
    navSolutionExceptionHub: "Hub de excepciones™",
    headerSearchPlaceholder: "Buscar productos",
    customerPanel: "Panel",
    heroSubtitle:
      "Acceda a fabricantes turcos verificados, reciba cotizaciones directas de fábrica de los equipos comerciales del fabricante, gestione la ejecución de órdenes de compra, compare ofertas de flete, reduzca el riesgo de abastecimiento con inspecciones y supervise la visibilidad de envíos, todo en una sola plataforma.",
    heroSearch: "Buscar productos, categorías o proveedores…",
    heroSearchBtn: "Buscar",
    heroCta: "Ver todos los productos",
    heroStats1: "Productos",
    heroStats3: "Países",
    browseCategories: "Explorar por categoría",
    categoriesSub: "Explore nuestra amplia gama de categorías de productos",
    viewAll: "Ver todo",
    allProducts: "Todos los productos",
    addToRfq: "Agregar a RFQ",
    added: "Agregado",
    minOrder: "Pedido min.",
    origin: "Origen",
    requestQuote: "Solicitar cotización",
    rfqTitle: "Cesta RFQ",
    rfqEmpty: "Su cesta RFQ esta vacia",
    rfqEmptySub: "Explore productos y agregue articulos para solicitar una cotizacion",
    rfqSubmit: "Enviar RFQ",
    rfqCompany: "Nombre de la empresa",
    rfqEmail: "Correo",
    rfqPhone: "Teléfono",
    rfqQuantity: "Cant.",
    rfqSuccess: "RFQ enviada con éxito",
    rfqSuccessSub: "Nuestro equipo revisara su solicitud y le contactara dentro de 24 horas.",
    liveChat: "Chat en vivo",
    liveChatSub: "¿Cómo podemos ayudarle hoy?",
    chatPlaceholder: "Escriba su mensaje...",
    chatWelcome: "Bienvenido. ¿Cómo podemos ayudarle con su compra mayorista?",
    aiAssistant: "Asistente IA Comercial",
    aiSub: "Pregunte sobre productos, envios o aduanas",
    aiPlaceholder: "Pregunte sobre productos turcos...",
    aiWelcome:
      "Hola. Soy su asistente IA comercial. Puedo ayudarle con productos, logística y aduanas. ¿Cómo puedo ayudarle?",
    footerDesc: "Su puerta global a productos turcos de calidad. Conectamos compradores internacionales con proveedores verificados.",
    quickLinks: "Enlaces rápidos",
    productCategories: "Categorías de productos",
    contactUs: "Contáctenos",
    allRights: "Todos los derechos reservados.",
    aboutTitle: "Comercio global, calidad turca",
    aboutDesc: "Conectamos empresas internacionales con fabricantes y proveedores turcos premium.",
    aboutDeMaxtoreHeading: "Sobre DeMaxtore",
    aboutBody1:
      "DeMaxtore Inc se fundo en 1999 como empresa internacional de marketing y gestion de la relacion con el cliente.",
    aboutBody2:
      "Demaxtore.com es una plataforma B2B integral que conecta a fabricantes y proveedores turcos con compradores de todo el mundo.",
    aboutBody3:
      "Contamos con muchos miembros suscritos, desde los mayores fabricantes de alta tecnologia hasta pequenos proveedores. La plataforma B2B Demaxtore.com ofrece servicio a compradores internacionales para encontrar productos de la mejor calidad a los mejores precios en Turquia.",
    aboutBody4:
      "Busque los productos que necesite y contacte directamente a los proveedores para obtener informacion sobre detalles tecnicos y ofertas de precio.",
    stat1Title: "Productos verificados",
    stat2Title: "Paises de exportacion",
    stat3Title: "Proveedores activos",
    stat4Title: "Pedidos completados",
    panelTitle: "Panel del cliente",
    panelRfqs: "Mis RFQ",
    panelProducts: "Productos guardados",
    panelSettings: "Configuracion",
    panelTotalRfq: "RFQ totales",
    panelPending: "Pendiente",
    panelApproved: "Aprobado",
    panelVolume: "Volumen comercial",
    contactTitle: "Póngase en contacto",
    contactSub: "¿Tiene preguntas? Envíenos un mensaje",
    contactName: "Su nombre",
    contactEmail: "Correo electrónico",
    contactCompany: "Nombre de la empresa",
    contactMessage: "Mensaje",
    contactSend: "Enviar mensaje",
    contactSent: "Mensaje enviado",
    filterAll: "Todas las categorías",
    noProducts: "No se encontraron productos",
    noProductsSub: "Pruebe ajustando su busqueda o filtros",
    authAccountAria: "Cuenta — iniciar sesion o registrarse",
    authAccountMenu: "Iniciar sesion o registrarse",
    authKicker: "Portal comprador B2B",
    authAsideHeadline: "Su equipo de abastecimiento mayorista en Turquia",
    authAside1: "RFQ revisadas por nuestro equipo comercial",
    authAside2: "Fabricantes evaluados para exportacion",
    authAside3: "Apoyo en precios, fichas tecnicas y documentacion",
    authTitle: "Iniciar sesion o registrarse",
    authSubtitle:
      "Use su correo corporativo para acceder a su espacio comprador o abrir un nuevo perfil. Envie RFQ desde el catalogo en cualquier momento: nuestro equipo da seguimiento a cada solicitud, con cuenta o como visitante.",
    authSignIn: "Iniciar sesion",
    authRegister: "Registrarse",
    authEmail: "Correo",
    authPassword: "Contraseña",
    authConfirmPassword: "Confirmar contraseña",
    authCompany: "Empresa (opcional)",
    authSubmitSignIn: "Entrar",
    authSubmitRegister: "Crear cuenta",
    authBackHome: "Volver al inicio",
    authEmailPlaceholder: "usted@empresa.com",
    authPasswordPlaceholder: "Introduzca su contraseña",
    authSuccessNotice:
      "Gracias: hemos registrado su solicitud. Nuestro equipo comercial se pondra en contacto en breve para completar el acceso. Mientras tanto, siga explorando y use la cesta RFQ con normalidad.",
    authFillRequired: "Introduzca correo y contraseña.",
    authPasswordMismatch: "Las contraseñas no coinciden.",
    authNeedHelp: "Necesita ayuda?",
    authContactLink: "Contactenos",
    authDemoDivider: "O pruebe un rol de demostración",
    authDemoBadge: "Demo en 1 clic",
    authDemoShipper: "Expedidor",
    authDemoForwarder: "Transitario",
    authDemoAdmin: "Admin",
    authDemoNotConfigured:
      "Este acceso demo no está configurado. Añada las credenciales en el entorno del sitio o inicie sesión manualmente.",
    authLayoutSignInHeading: "Iniciar sesión",
    authLayoutDontHave: "¿No tiene cuenta?",
    authSignUpLink: "Registrarse",
    accountForgotPassword: "¿Olvidó su contraseña? Contáctenos",
    accountSigningIn: "Iniciando sesión…",
    accountCreating: "Creando cuenta…",
    accountLoginFailed: "Error al iniciar sesión.",
    accountRegisterFailed: "No se pudo crear la cuenta.",
    accountPasswordMin: "La contraseña debe tener al menos 8 caracteres.",
    accountMyRfqsTitle: "Sus solicitudes de cotización enviadas",
    accountMyRfqsDesc:
      "Las cotizaciones aparecen aquí cuando el correo RFQ coincide con esta cuenta — use el mismo correo en el formulario RFQ.",
    accountSignOut: "Cerrar sesión",
    accountLoadingRfqs: "Cargando…",
    accountNoRfqsYet:
      "Aún no hay RFQ. Abra la cesta RFQ y envíe una solicitud con el correo de su cuenta.",
    blog: "Blog",
    blogPageTitle: "Ideas de comercio",
    blogPageSubtitle:
      "Notas breves sobre abastecimiento al por mayor, RFQ y trabajo con proveedores turcos verificados.",
    blog_post1_title: "Cotizaciones mas precisas con su RFQ",
    blog_post1_meta: "marzo 2025",
    blog_post1_excerpt:
      "Indique cantidades, embalaje, puerto de destino y plazo deseado. Los proveedores responden antes cuando los requisitos son concretos y se evitan idas y vueltas innecesarias.",
    blog_post2_title: "Por que los compradores abastecen FMCG y materiales desde Turquia",
    blog_post2_meta: "enero 2025",
    blog_post2_excerpt:
      "Fabricacion a escala, precios al por mayor competitivos y experiencia en documentacion de exportacion hacen de Turquia un centro practico, desde alimentos hasta consumibles de obra.",
    blog_post3_title: "Antes del primer envio: comprobaciones simples al proveedor",
    blog_post3_meta: "noviembre 2024",
    blog_post3_excerpt:
      "Pida referencias en su region, confirme certificaciones relevantes para su mercado y acuerde muestras o especificaciones por escrito. Unos pasos claros reducen el riesgo en los primeros pedidos.",
    blogCtaTitle: "Listo para solicitar una cotizacion?",
    blogCtaSub: "Explore el catalogo o agregue lineas a la cesta RFQ — nuestro equipo da seguimiento a cada envio.",
    blog_hero_kicker: "Ideas para compradores mayoristas",
    blog_featured: "Destacado",
    blog_tag_rfq: "RFQ y cotizaciones",
    blog_tag_markets: "Mercados y Turquia",
    blog_tag_quality: "Riesgo y calidad",
    blog_est_read: "Lectura ~3 min",
    blogReadArticle: "Leer articulo",
    blogBackToList: "Todos los articulos",
    wishlist: "Lista de deseos",
    wishlistAria: "Lista de deseos — productos guardados",
    wishlistPageTitle: "Tu lista de deseos",
    wishlistPageSubtitle: "Los productos que guardaste con el icono de corazon aparecen aqui.",
    wishlistEmptyTitle: "Tu lista esta vacia",
    wishlistEmptySub: "Explora el catalogo y toca el corazon en cualquier producto para guardarlo aqui.",
    wishlistLoading: "Cargando tus productos guardados…",
    wishlistBrowseCta: "Ver productos",
    inspectionDocs: "Documentos de calidad",
    inspectionChecklist: "Lista de verificación",
    inspectionReport: "Informe de inspección",
    freightIqLogoAlt: "FreightIQ — Decisiones inteligentes de flete",
    freightIqLivePill: "Tarifas de flete en vivo",
    freightIqHeadlineLead: "Decisiones de flete inteligentes,",
    freightIqHeadlineAccent: "todo en un solo lugar.",
    freightIqDescription:
      "Compare ofertas de flete de más de {count} transitarios. Evalúe tiempos de tránsito y costes, y elija la mejor opción con confianza.",
    freightIqDescriptionCount: "500+",
    freightTrustCarriers: "500+ transitarios",
    freightTrustCountries: "120+ países",
    freightTrustForwarders: "Transitarios verificados",
    freightDeparturePort: "Puerto de origen",
    freightDestinationPort: "Puerto de destino",
    freightCargoDetails: "Detalles de la carga",
    freightCargoType: "Tipo de carga",
    freightPhCityPort: "Ciudad o puerto",
    freightPhCargoDetails: "Detalles de la carga",
    freightPhCargoType: "Describa su mercancía",
    freightLoadingInterval: "Intervalo de carga estimado",
    freightDateFrom: "Desde",
    freightDateTo: "Hasta",
    freightDateFromAria: "Fecha inicial",
    freightDateToAria: "Fecha final",
    freightSearchAria: "Buscar flete",
    freightSubmitQuoteAria: "Enviar solicitud de cotización de flete",
    freightInquiry: "Consulta de flete",
    freightSearch: "Buscar",
    freightSubmitCta: "Solicitar cotización",
    freightRequesterEmail: "Su correo",
    freightPhRequesterEmail: "nombre@empresa.com",
    freightSubmitting: "Enviando…",
    freightSentThanks: "Hemos recibido su consulta y hemos notificado a los transitarios.",
    freightSubmitError: "No se pudo enviar. Inténtelo de nuevo en un momento.",
    freightFillRequired: "Complete todos los campos, incluido su correo.",
    freightQuoteSentTitle: "Su solicitud ha sido enviada",
    freightQuoteSentSub:
      "Se ha guardado y se ha enviado a las personas pertinentes. Recibirá las cotizaciones como notificaciones.",
    freightTrackKicker: "VISIBILIDAD DE ENVÍOS",
    freightTrackTitleA: "Visibilidad marítima en tiempo real con",
    freightTrackTitleB: "inteligencia ETA",
    freightTrackSub:
      "Siga sus envíos marítimos desde el puerto de salida hasta el puerto de llegada con visibilidad en tiempo real, monitoreo ETA y alertas proactivas de retraso. Manténgase informado en cada hito y planifique con mayor confianza.",
    freightTrackFeature1Title: "Visibilidad en tiempo real",
    freightTrackFeature1Desc: "Siga su buque y el progreso del envío en un mapa en vivo.",
    freightTrackFeature2Title: "Monitoreo ETA",
    freightTrackFeature2Desc: "Manténgase al día con los cambios de llegada estimada en tiempo real.",
    freightTrackFeature3Title: "Alertas de retraso",
    freightTrackFeature3Desc: "Reciba notificaciones proactivas por retrasos y perturbaciones en tránsito.",
    freightTrackFeature4Title: "Hitos del envío",
    freightTrackFeature4Desc: "Supervise cada hito clave desde la salida hasta la llegada al puerto.",
    freightTrackCta: "Rastrear su envío",
    freightTrackEtaLabel: "Llegada estimada",
    freightTrackEtaSub: "Faltan 3 dias",
    freightTrackLocLabel: "Ubicacion actual",
    freightTrackLocValue: "Al norte del canal de Suez",
    freightTrackLocBadge: "Buque en transito",
    freightTrackVesselLabel: "Buque",
    freightTrackVesselName: "MSC AURORA",
    freightTrackVesselType: "Portacontenedores",
    freightTrackNextPortLabel: "Proximo puerto",
    freightTrackNextPortValue: "Jebel Ali, EAU",
    freightTrackNextEtaPrefix: "ETA:",
    freightTrackStepDeparted: "Salida (10 may)",
    freightTrackStepTransit: "En transito",
    freightTrackStepOnWay: "En camino",
    freightTrackStepArriving: "Llegando pronto",
    freightTrackMapAlt: "Ilustracion: ruta maritima y puertos",
    freightTrackLogoAlt: "DeMaxtore — Seguimiento de envíos en vivo",
    inspectionShowLogoAlt: "DeMaxtore Inspection",
    inspectionShowKicker: "Inspeccion y verificacion",
    inspectionShowTitleA: "Verifique sus productos",
    inspectionShowTitleB1: "antes del",
    inspectionShowTitleB2: "envío",
    inspectionShowSub: "Reduzca riesgos, asegure calidad y envie con confianza.",
    inspectionShowHeroAlt: "Inspector frente a contenedor con lista de verificacion",
    inspectionShowFeat1Title: "Inspeccion de calidad",
    inspectionShowFeat1Desc: "Inspeccion independiente antes del embarque.",
    inspectionShowFeat2Title: "Informes foto y video",
    inspectionShowFeat2Desc: "Vea exactamente lo que se envia.",
    inspectionShowFeat3Title: "Informes de inspeccion detallados",
    inspectionShowFeat3Desc: "Documentacion clara del estado del producto.",
    inspectionShowFeat4Title: "Reduccion de riesgos",
    inspectionShowFeat4Desc: "Detecte problemas antes de que cuesten caro.",
    inspectionShowTrust1: "Inspecciones independientes y fiables",
    inspectionShowTrust2: "Confianza de importadores globales.",
    inspectionShowChecklistTitle: "Lista de inspeccion",
    inspectionShowCheckPackaging: "Estado del embalaje",
    inspectionShowCheckQty: "Cantidad de producto",
    inspectionShowCheckQuality: "Calidad del producto",
    inspectionShowCheckLabel: "Etiqueta y marcado",
    inspectionShowCheckCarton: "Dano en carton",
    inspectionShowStatusOk: "OK",
    inspectionShowStatusMinor: "Menor",
    inspectionShowCompletedBar: "Inspeccion completada",
    inspectionShowCompletedWhen: "18 may 2025 • 10:30",
    inspectionShowThumbPackaging: "Embalaje",
    inspectionShowThumbQuantity: "Cantidad",
    inspectionShowThumbQuality: "Control de calidad",
    inspectionShowThumbLabel: "Etiqueta y marcado",
    inspectionShowThumbReport: "Informe",
    smartSourceAria:
      "CommodityBid — FEATURE POINTS. Sourcing mas inteligente. Mejores precios. Decisiones mas solidas.",
    smartSourceBadge: "Precio primero. Valor entregado.",
    smartSourceTitleLine1: "Sourcing mas inteligente.",
    smartSourceTitleLine2: "Mejores precios.",
    smartSourceSubtitle:
      "Sourcing mas inteligente.\nMejores precios.\nDecisiones mas solidas.",
    smartSourceFeat1Title: "Precios basados en el mercado",
    smartSourceFeat1Desc: "Acceda a ofertas competitivas alineadas con las condiciones actuales del mercado.",
    smartSourceFeat2Title: "Comparación estructurada",
    smartSourceFeat2Desc: "Revise varias cotizaciones de proveedores en una sola vista clara.",
    smartSourceFeat3Title: "Toma de decisiones más rápida",
    smartSourceFeat3Desc: "Reciba y evalúe ofertas sin demoras.",
    smartSourceFeat4Title: "Los precios más bajos del mercado",
    smartSourceFeat4Desc: "Compare ofertas y asegure precios de mercado competitivos.",
    smartSourceCardBest: "Mejor precio",
    smartSourceCardPrice: "1.245 $",
    smartSourceCardUnit: "/t",
    smartSourceCardDelta: "+4,2 % vs semana pasada",
    smartSourceCardTrend: "Tendencia de mercado",
    smartSourceCardTrendPct: "+4,2 %",
    smartSourceMicroLbl: "Micro valor",
    smartSourceMicroDesc: "Pensado para el sourcing de commodities guiado por el precio.",
    smartSourcePhotoAlt: "Contenedores en el puerto al anochecer",
    smartBentoHeroTitle1: "FEATURE",
    smartBentoHeroTitle2: "POINTS",
    smartBentoHeroLine1: "Sourcing mas inteligente.",
    smartBentoHeroLine2: "Mejores precios.",
    smartBentoHeroLine3: "Decisiones mas solidas.",
    smartBentoHeroLogoAlt: "CommodityBid — Encuentre el mejor precio",
    smartBentoFeatureHeroParagraph:
      "Acceda a ofertas competitivas, compare\nvarios proveedores y tome decisiones\nde abastecimiento más rápidas y acertadas.",
    smartBentoMicroLine1: "Pensado para el sourcing",
    smartBentoMicroLine2: "de commodities guiado por el precio.",
    smartBentoImgContainersAlt: "Contenedores apilados",
    smartBentoImgGlobeAlt: "Red comercial global",
    smartBentoImgMagnifierAlt: "Graficos y analisis",
    smartBentoImgLaptopAlt: "Panel en portatil",
    smartBentoImgTimerAlt: "Cronometro",
    smartBentoImgChartAlt: "Grafico de precios",
    smartBentoImgCargoAlt: "Buque de carga en puerto",
    smartBentoCreateBid: "Crear una oferta",
    smartBentoCard3Title: "ACCESO GLOBAL A COMMODITIES",
    smartBentoCard3Desc:
      "Los mercados de commodities se mueven rapido. Reuna varias ofertas de proveedores de forma estructurada e identifique el mejor precio disponible — con rapidez y claridad.",
    smartBentoFooter1: "PRECIOS COMPETITIVOS",
    smartBentoFooter2: "PROVEEDORES DE CONFIANZA",
    smartBentoFooter3: "INSIGHTS BASADOS EN DATOS",
    smartBentoFooter4: "RAPIDO Y EFICIENTE",
    cookieBannerBefore:
      "Usamos cookies para mejorar la experiencia y para estadísticas de uso anónimas. Para más detalles consulte nuestra",
    cookieBannerLink: "Política de cookies",
    cookieBannerAfter: ".",
    cookieAccept: "Aceptar cookies",
    cookieBannerAria: "Aviso de cookies",
    productVerifiedSupplier: "Proveedor verificado",
    footerCategoryUncategorized: "Sin categoría",
    footerLinkWebsitePrivacy: "Aviso de privacidad del sitio web",
    footerLinkPrivacy: "Política de privacidad",
    footerLinkCookies: "Política de cookies",
    footerLogoAlt: "DeMaxtore — Conecta compradores con proveedores turcos",
    highlightLabelProductQuality: "Calidad del producto",
    highlightLabelProductSizes: "Tamaños del producto",
    highlightLabelPackageSizes: "Tamaños de envase",
    highlightLabelPackageQuantitiesCarton: "Cantidades por caja",
    highlightLabelShelfLife: "Vida útil",
    highlightLabelPrivateLabel: "Producción de marca privada",
    highlightLabelPrivateLabelShort: "Marca privada",
    highlightLabelNetWeight: "Peso neto",
    highlightLabelStorage: "Almacenamiento",
    highlightLabelIngredients: "Ingredientes",
    highlightLabelCertification: "Certificación",
    highlightValueAvailable: "Disponible",
    highlightValueNotAvailable: "No disponible",
    highlightValueYes: "Sí",
    highlightValueNo: "No",
  },
  ar: {
    home: "الرئيسية",
    products: "المنتجات",
    categories: "الفئات",
    about: "من نحن",
    contact: "اتصل بنا",
    rfqBasket: "سلة الطلب",
    rfqBasketShort: "RFQ",
    solutions: "الحلول",
    procurementModels: "نماذج التوريد",
    procurementModelsShort: "التوريد",
    headerLiveShipmentTracking: "تتبع الشحنات المباشر",
    navSolutionGroupB2bSourcing: "التوريد B2B",
    navSolutionGroupProcurementModel: "نموذج التوريد",
    navSolutionGroupDigitalFreight: "تنفيذ الشحن الرقمي",
    navSolutionGroupImportControlTower: "برج مراقبة الاستيراد",
    navSolutionRfq: "RFQ™",
    navSolutionCommodityBid: "CommodityBid™",
    navSolutionVerifiedManufacturers: "مصنعون موثقون™",
    navSolutionFreightIq: "FreightIQ™",
    navSolutionCarrierCoordination: "تنسيق الناقلين™",
    navSolutionFreightBooking: "حجز الشحن™",
    navSolutionEstimatedCif: "CIF المقدر™",
    navSolutionBulkContainer: "حاوية بالجملة™",
    navSolutionFullContainer: "حاوية كاملة™",
    navSolutionSmartContainer: "حاوية ذكية™",
    navSolutionInspection: "التفتيش™",
    navSolutionShipmentTracking: "تتبع الشحنات المباشر™",
    navSolutionDocumentCenter: "مركز المستندات™",
    navSolutionExceptionHub: "مركز الاستثناءات™",
    headerSearchPlaceholder: "ابحث عن المنتجات",
    customerPanel: "لوحة التحكم",
    heroSubtitle:
      "احصل على مصنعين أتراك موثقين، واستلم عروض أسعار مباشرة من فرق مبيعات المصنع، وأدر تنفيذ أوامر الشراء، وقارن عروض الشحن، وقلل مخاطر التوريد عبر عمليات التفتيش، وراقب رؤية الشحنات، كل ذلك في منصة واحدة.",
    heroSearch: "ابحث عن المنتجات او الفئات او الموردين...",
    heroSearchBtn: "بحث",
    heroCta: "عرض جميع المنتجات",
    heroStats1: "منتجات",
    heroStats3: "دول",
    browseCategories: "تصفح حسب الفئة",
    categoriesSub: "استكشف مجموعتنا الواسعة من فئات المنتجات",
    viewAll: "عرض الكل",
    allProducts: "جميع المنتجات",
    addToRfq: "اضافة الى السلة",
    added: "تمت الاضافة",
    minOrder: "الحد الادنى",
    origin: "المنشأ",
    requestQuote: "طلب عرض سعر",
    rfqTitle: "سلة الطلب",
    rfqEmpty: "سلة الطلب فارغة",
    rfqEmptySub: "تصفح المنتجات واضف العناصر لطلب عرض سعر",
    rfqSubmit: "ارسال الطلب",
    rfqCompany: "اسم الشركة",
    rfqEmail: "البريد الالكتروني",
    rfqPhone: "الهاتف",
    rfqQuantity: "الكمية",
    rfqSuccess: "تم ارسال الطلب بنجاح",
    rfqSuccessSub: "سيقوم فريقنا بمراجعة طلبك والتواصل معك خلال 24 ساعة.",
    liveChat: "دردشة مباشرة",
    liveChatSub: "كيف يمكننا مساعدتك اليوم؟",
    chatPlaceholder: "اكتب رسالتك...",
    chatWelcome: "مرحبا! كيف يمكننا مساعدتك في مشتريات الجملة؟",
    aiAssistant: "مساعد التجارة الذكي",
    aiSub: "اسأل عن المنتجات او الشحن او الجمارك",
    aiPlaceholder: "اسأل عن المنتجات التركية...",
    aiWelcome: "مرحبا! انا مساعدك الذكي للتجارة. يمكنني مساعدتك في المنتجات والخدمات اللوجستية والجمارك.",
    footerDesc: "بوابتك العالمية الى المنتجات التركية عالية الجودة. نربط المشترين الدوليين بالموردين الموثوقين.",
    quickLinks: "روابط سريعة",
    productCategories: "فئات المنتجات",
    contactUs: "اتصل بنا",
    allRights: "جميع الحقوق محفوظة.",
    aboutTitle: "تجارة عالمية وجودة تركية",
    aboutDesc: "نربط الشركات الدولية بالمصنعين والموردين الاتراك المتميزين.",
    aboutDeMaxtoreHeading: "عن DeMaxtore",
    aboutBody1:
      "تأسست DeMaxtore Inc عام 1999 كشركة دولية للتسويق وادارة علاقات العملاء.",
    aboutBody2:
      "Demaxtore.com منصة اعمال شاملة (B2B) تربط المصنعين والموردين الاتراك بالمشترين من مختلف انحاء العالم.",
    aboutBody3:
      "لدينا عدد كبير من الاعضاء المشتركين من كبرى المصانع عالية التقنية الى موردين صغار. توفر منصة Demaxtore.com B2B خدمات للمشترين الدوليين للعثور على منتجات بجودة عالية بافضل الاسعار في تركيا.",
    aboutBody4:
      "ابحث عن المنتجات التي تحتاجها وتواصل مباشرة مع الموردين للحصول على معلومات حول التفاصيل التقنية للمنتج وعروض الاسعار.",
    stat1Title: "منتجات موثقة",
    stat2Title: "دول التصدير",
    stat3Title: "موردون نشطون",
    stat4Title: "طلبات مكتملة",
    panelTitle: "لوحة العميل",
    panelRfqs: "طلباتي",
    panelProducts: "المنتجات المحفوظة",
    panelSettings: "الاعدادات",
    panelTotalRfq: "اجمالي الطلبات",
    panelPending: "قيد الانتظار",
    panelApproved: "مقبول",
    panelVolume: "حجم التجارة",
    contactTitle: "تواصل معنا",
    contactSub: "هل لديك اسئلة؟ ارسل لنا رسالة",
    contactName: "اسمك",
    contactEmail: "البريد الالكتروني",
    contactCompany: "اسم الشركة",
    contactMessage: "الرسالة",
    contactSend: "ارسال الرسالة",
    contactSent: "تم ارسال الرسالة",
    filterAll: "جميع الفئات",
    noProducts: "لم يتم العثور على منتجات",
    noProductsSub: "حاول تعديل البحث او الفلاتر",
    authAccountAria: "الحساب — تسجيل الدخول او انشاء حساب",
    authAccountMenu: "تسجيل الدخول او التسجيل",
    authKicker: "بوابة مشترين B2B",
    authAsideHeadline: "مكتب توريدكم بالجملة من تركيا",
    authAside1: "متابعة طلبات العرض من فريقنا التجاري",
    authAside2: "مصنعون تم التحقق من جاهزيتهم للتصدير",
    authAside3: "دعم في الاسعار والمواصفات والوثائق",
    authTitle: "تسجيل الدخول او انشاء حساب",
    authSubtitle:
      "استخدم بريد شركتك للوصول الى مساحة المشتري او فتح ملف جديد. قدم طلبات عرض السعر من الكتالوج في اي وقت — يتابع فريقنا كل طلب، سواء كان لديك حساب ام لا.",
    authSignIn: "تسجيل الدخول",
    authRegister: "التسجيل",
    authEmail: "البريد الالكتروني",
    authPassword: "كلمة المرور",
    authConfirmPassword: "تأكيد كلمة المرور",
    authCompany: "الشركة (اختياري)",
    authSubmitSignIn: "دخول",
    authSubmitRegister: "انشاء حساب",
    authBackHome: "العودة للرئيسية",
    authEmailPlaceholder: "you@company.com",
    authPasswordPlaceholder: "ادخل كلمة المرور",
    authSuccessNotice:
      "شكرا لك — تم تسجيل طلبك. سيتواصل فريقنا التجاري قريبا لاستكمال صلاحية الدخول. يمكنك متابعة التصفح واستخدام سلة الطلب كالمعتاد.",
    authFillRequired: "يرجى ادخال البريد وكلمة المرور.",
    authPasswordMismatch: "كلمتا المرور غير متطابقتين.",
    authNeedHelp: "تحتاج مساعدة؟",
    authContactLink: "اتصل بنا",
    authDemoDivider: "أو جرّب دورًا تجريبيًا",
    authDemoBadge: "تجربة بنقرة واحدة",
    authDemoShipper: "الشاحن",
    authDemoForwarder: "الوسيط",
    authDemoAdmin: "المسؤول",
    authDemoNotConfigured:
      "لم يُضبط هذا الاختصار التجريبي. أضف بيانات الدخول في بيئة الموقع أو سجّل الدخول يدويًا.",
    authLayoutSignInHeading: "تسجيل الدخول",
    authLayoutDontHave: "ليس لديك حساب؟",
    authSignUpLink: "إنشاء حساب",
    accountForgotPassword: "نسيت كلمة المرور؟ تواصل معنا",
    accountSigningIn: "جارٍ تسجيل الدخول…",
    accountCreating: "جارٍ إنشاء الحساب…",
    accountLoginFailed: "فشل تسجيل الدخول.",
    accountRegisterFailed: "تعذر إنشاء الحساب.",
    accountPasswordMin: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
    accountMyRfqsTitle: "طلبات عروض الأسعار المرسلة",
    accountMyRfqsDesc:
      "تظهر العروض هنا عندما يطابق بريد RFQ هذا الحساب — استخدم نفس البريد في نموذج RFQ.",
    accountSignOut: "تسجيل الخروج",
    accountLoadingRfqs: "جارٍ التحميل…",
    accountNoRfqsYet:
      "لا توجد طلبات بعد. افتح سلة RFQ وأرسل طلبًا باستخدام بريد حسابك.",
    blog: "المدونة",
    blogPageTitle: "رؤى تجارية",
    blogPageSubtitle:
      "ملاحظات موجزة حول التوريد بالجملة وطلبات عروض الاسعار والتعامل مع موردين اتراك موثوقين.",
    blog_post1_title: "عروض اسعار اوضح عبر طلبك",
    blog_post1_meta: "مارس 2025",
    blog_post1_excerpt:
      "اذكر الكميات والتعبئة وميناء الوصول والجدول الزمني المستهدف. يستجيب الموردون اسرع عندما تكون المتطلبات واضحة وتقل الرسائل المتكررة حول التفاصيل الاساسية.",
    blog_post2_title: "لماذا يتجه المشترون الى تركيا لمواد الاستهلاك والبناء",
    blog_post2_meta: "يناير 2025",
    blog_post2_excerpt:
      "تصنيع واسع النطاق واسعار جملة تنافسية وخبرة في وثائق التصدير تجعل تركيا مركزا عمليا من الغذاء الى مستلزمات البناء.",
    blog_post3_title: "قبل اول شحنة: فحوصات بسيطة للمورد",
    blog_post3_meta: "نوفمبر 2024",
    blog_post3_excerpt:
      "اطلب مراجع في منطقتك، واكد الشهادات المناسبة لسوقك، واتفق على العينات او المواصفات كتابة. خطوات واضحة تقلل المخاطر في الطلبات الاولى.",
    blogCtaTitle: "جاهز لطلب عرض سعر؟",
    blogCtaSub: "تصفح الكتالوج او اضف بنودا الى سلة الطلب — يتابع فريقنا كل طلب.",
    blog_hero_kicker: "معرفة لمشتري الجملة",
    blog_featured: "مختار",
    blog_tag_rfq: "طلب العرض والأسعار",
    blog_tag_markets: "الأسواق وتركيا",
    blog_tag_quality: "المخاطر والجودة",
    blog_est_read: "قراءة تقريبية ٣ دقائق",
    blogReadArticle: "اقرأ المقال",
    blogBackToList: "كل المقالات",
    wishlist: "قائمة الرغبات",
    wishlistAria: "قائمة الرغبات — المنتجات المحفوظة",
    wishlistPageTitle: "قائمة رغباتك",
    wishlistPageSubtitle: "تظهر هنا المنتجات التي حفظتها عبر ايقونة القلب.",
    wishlistEmptyTitle: "قائمة الرغبات فارغة",
    wishlistEmptySub: "تصفح الكتالوج واضغط القلب على اي منتج لحفظه هنا.",
    wishlistLoading: "جاري تحميل المنتجات المحفوظة…",
    wishlistBrowseCta: "تصفح المنتجات",
    inspectionDocs: "وثائق الجودة",
    inspectionChecklist: "قائمة التفتيش",
    inspectionReport: "تقرير التفتيش",
    freightIqLogoAlt: "FreightIQ — قرارات شحن ذكية",
    freightIqLivePill: "أسعار شحن مباشرة",
    freightIqHeadlineLead: "قرارات شحن ذكية،",
    freightIqHeadlineAccent: "كلها في مكان واحد.",
    freightIqDescription:
      "قارن عروض أسعار الشحن من أكثر من {count} وسيط شحن. قيّم أوقات العبور والتكاليف، واختر الخيار الأنسب بثقة.",
    freightIqDescriptionCount: "٥٠٠+",
    freightTrustCarriers: "+٥٠٠ وسيط شحن",
    freightTrustCountries: "+١٢٠ دولة",
    freightTrustForwarders: "وسطاء شحن موثقون",
    freightDeparturePort: "ميناء المغادرة",
    freightDestinationPort: "ميناء الوصول",
    freightCargoDetails: "تفاصيل الشحنة",
    freightCargoType: "نوع البضاعة",
    freightPhCityPort: "أدخل المدينة أو الميناء",
    freightPhCargoDetails: "أدخل تفاصيل الشحنة",
    freightPhCargoType: "صف بضاعتك",
    freightLoadingInterval: "الفترة التقديرية للتحميل",
    freightDateFrom: "من",
    freightDateTo: "إلى",
    freightDateFromAria: "تاريخ البداية",
    freightDateToAria: "تاريخ النهاية",
    freightSearchAria: "بحث الشحن",
    freightSubmitQuoteAria: "إرسال طلب عرض سعر الشحن",
    freightInquiry: "استعلام شحن",
    freightSearch: "بحث",
    freightSubmitCta: "طلب عرض سعر",
    freightRequesterEmail: "بريدك الإلكتروني",
    freightPhRequesterEmail: "name@company.com",
    freightSubmitting: "جارٍ الإرسال…",
    freightSentThanks: "استلمنا استفسارك وأبلغنا شركات الشحن.",
    freightSubmitError: "تعذر الإرسال. يرجى المحاولة مرة أخرى بعد قليل.",
    freightFillRequired: "يرجى تعبئة جميع الحقول، بما في ذلك بريدك الإلكتروني.",
    freightQuoteSentTitle: "تم إرسال طلبكم بنجاح",
    freightQuoteSentSub:
      "تم حفظ طلبكم وإرساله إلى الجهات المعنية. ستصلكم عروض الأسعار على شكل إشعارات.",
    freightTrackKicker: "رؤية الشحنات",
    freightTrackTitleA: "رؤية الشحنات البحرية في الوقت الفعلي مع",
    freightTrackTitleB: "ذكاء وقت الوصول المتوقع",
    freightTrackSub:
      "تتبع شحناتك البحرية من ميناء المغادرة إلى ميناء الوصول برؤية فورية ومراقبة ETA وتنبيهات استباقية للتأخير. ابقَ على اطلاع عند كل مرحلة وخطّط بثقة أكبر.",
    freightTrackFeature1Title: "رؤية في الوقت الفعلي",
    freightTrackFeature1Desc: "تابع السفينة وتقدم الشحنة على خريطة حية.",
    freightTrackFeature2Title: "مراقبة ETA",
    freightTrackFeature2Desc: "ابقَ على اطلاع بتغييرات وقت الوصول المتوقع في الوقت الفعلي.",
    freightTrackFeature3Title: "تنبيهات التأخير",
    freightTrackFeature3Desc: "تلقَّ إشعارات استباقية عند التأخير أو اضطرابات العبور.",
    freightTrackFeature4Title: "مراحل الشحنة",
    freightTrackFeature4Desc: "راقب كل مرحلة رئيسية من المغادرة حتى الوصول إلى الميناء.",
    freightTrackCta: "تتبع شحنتك",
    freightTrackEtaLabel: "الوصول المتوقع",
    freightTrackEtaSub: "متبقي 3 ايام",
    freightTrackLocLabel: "الموقع الحالي",
    freightTrackLocValue: "شمال قناة السويس",
    freightTrackLocBadge: "السفينة في عبور",
    freightTrackVesselLabel: "السفينة",
    freightTrackVesselName: "MSC AURORA",
    freightTrackVesselType: "حاويات",
    freightTrackNextPortLabel: "الموقع القادم",
    freightTrackNextPortValue: "جبل علي، الامارات",
    freightTrackNextEtaPrefix: "الوصول:",
    freightTrackStepDeparted: "المغادرة (10 مايو)",
    freightTrackStepTransit: "في العبور",
    freightTrackStepOnWay: "في الطريق",
    freightTrackStepArriving: "اقتراب الوصول",
    freightTrackMapAlt: "رسم توضيحي لمسار الشحن البحري",
    freightTrackLogoAlt: "DeMaxtore — تتبع الشحنات المباشر",
    inspectionShowLogoAlt: "DeMaxtore Inspection",
    inspectionShowKicker: "التفتيش والتحقق",
    inspectionShowTitleA: "تحقق من منتجاتك",
    inspectionShowTitleB1: "قبل",
    inspectionShowTitleB2: "الشحن",
    inspectionShowSub: "قلل المخاطر، تأكد من الجودة، واشحن بثقة.",
    inspectionShowHeroAlt: "مفتش أمام حاوية شحن مع قائمة تفتيش",
    inspectionShowFeat1Title: "تفتيش الجودة",
    inspectionShowFeat1Desc: "تفتيش مستقل قبل الشحن.",
    inspectionShowFeat2Title: "تقارير صور وفيديو",
    inspectionShowFeat2Desc: "شاهد بالضبط ما يُشحن.",
    inspectionShowFeat3Title: "تقارير تفتيش مفصلة",
    inspectionShowFeat3Desc: "توثيق واضح لحالة المنتج.",
    inspectionShowFeat4Title: "تخفيض المخاطر",
    inspectionShowFeat4Desc: "اكتشف المشكلات قبل أن تكلفك باهظاً.",
    inspectionShowTrust1: "تفتيش مستقل وموثوق",
    inspectionShowTrust2: "موثوق به لدى المستوردين حول العالم.",
    inspectionShowChecklistTitle: "قائمة التفتيش",
    inspectionShowCheckPackaging: "حالة التعبئة",
    inspectionShowCheckQty: "كمية المنتج",
    inspectionShowCheckQuality: "جودة المنتج",
    inspectionShowCheckLabel: "التوسيم والعلامات",
    inspectionShowCheckCarton: "تلف الكرتون",
    inspectionShowStatusOk: "مقبول",
    inspectionShowStatusMinor: "طفيف",
    inspectionShowCompletedBar: "اكتمل التفتيش",
    inspectionShowCompletedWhen: "١٨ مايو ٢٠٢٥ • ١٠:٣٠ ص",
    inspectionShowThumbPackaging: "التعبئة",
    inspectionShowThumbQuantity: "الكمية",
    inspectionShowThumbQuality: "فحص الجودة",
    inspectionShowThumbLabel: "التوسيم والعلامات",
    inspectionShowThumbReport: "التقرير",
    smartSourceAria:
      "CommodityBid — FEATURE POINTS. توريد أذكى. أسعار أفضل. قرارات أقوى.",
    smartSourceBadge: "السعر أولاً. القيمة تُسلَّم.",
    smartSourceTitleLine1: "توريد أذكى.",
    smartSourceTitleLine2: "أسعار أفضل.",
    smartSourceSubtitle:
      "توريد أذكى.\nأسعار أفضل.\nقرارات أقوى.",
    smartSourceFeat1Title: "تسعير مبني على السوق",
    smartSourceFeat1Desc: "اطلع على عروض تنافسية متوافقة مع الظروف الحالية للسوق.",
    smartSourceFeat2Title: "مقارنة منظمة",
    smartSourceFeat2Desc: "راجع عروض أسعار عدة موردين في عرض واحد واضح.",
    smartSourceFeat3Title: "اتخاذ قرارات أسرع",
    smartSourceFeat3Desc: "استلم وقيّم العروض دون تأخير.",
    smartSourceFeat4Title: "أدنى أسعار السوق",
    smartSourceFeat4Desc: "قارن العروض واحصل على أسعار سوق تنافسية.",
    smartSourceCardBest: "أفضل سعر",
    smartSourceCardPrice: "1,245 $",
    smartSourceCardUnit: "/طن",
    smartSourceCardDelta: "+4.2% مقارنة بالأسبوع الماضي",
    smartSourceCardTrend: "اتجاه السوق",
    smartSourceCardTrendPct: "+4.2%",
    smartSourceMicroLbl: "قيمة دقيقة",
    smartSourceMicroDesc: "مصمم لتوريد السلع الأساسية الموجّه بالسعر.",
    smartSourcePhotoAlt: "حاويات شحن في الميناء عند الغسق",
    smartBentoHeroTitle1: "FEATURE",
    smartBentoHeroTitle2: "POINTS",
    smartBentoHeroLine1: "توريد أذكى.",
    smartBentoHeroLine2: "أسعار أفضل.",
    smartBentoHeroLine3: "قرارات أقوى.",
    smartBentoHeroLogoAlt: "CommodityBid — اعثر على أفضل سعر",
    smartBentoFeatureHeroParagraph:
      "احصل على عروض تنافسية، قارن بين\nعدة موردين، واتخذ قرارات توريد\nأسرع وأكثر ذكاءً.",
    smartBentoMicroLine1: "مصمم لتوريد السلع",
    smartBentoMicroLine2: "الأساسية الموجّه بالسعر.",
    smartBentoImgContainersAlt: "حاويات مكدسة",
    smartBentoImgGlobeAlt: "شبكة تجارية عالمية",
    smartBentoImgMagnifierAlt: "رسوم بيانية وتحليلات",
    smartBentoImgLaptopAlt: "لوحة معلومات على حاسوب محمول",
    smartBentoImgTimerAlt: "ساعة توقيت",
    smartBentoImgChartAlt: "مخطط أسعار",
    smartBentoImgCargoAlt: "سفينة شحن في الميناء",
    smartBentoCreateBid: "إنشاء عرض",
    smartBentoCard3Title: "وصول عالمي للسلع الأساسية",
    smartBentoCard3Desc:
      "أسواق السلع تتحرك بسرعة. اجمع عروض عدة موردين بشكل منظم وحدد أفضل سعر متاح — بسرعة ووضوح.",
    smartBentoFooter1: "تسعير تنافسي",
    smartBentoFooter2: "موردون موثوقون",
    smartBentoFooter3: "رؤى مبنية على البيانات",
    smartBentoFooter4: "سريع وفعّال",
    cookieBannerBefore:
      "نستخدم ملفات تعريف الارتباط لتحسين التجربة ولإحصاءات استخدام مجهولة. للتفاصيل راجع",
    cookieBannerLink: "سياسة ملفات الارتباط",
    cookieBannerAfter: ".",
    cookieAccept: "قبول ملفات الارتباط",
    cookieBannerAria: "إشعار ملفات الارتباط",
    productVerifiedSupplier: "مورد موثق",
    footerCategoryUncategorized: "غير مصنف",
    footerLinkWebsitePrivacy: "إشعار خصوصية الموقع",
    footerLinkPrivacy: "سياسة الخصوصية",
    footerLinkCookies: "سياسة ملفات الارتباط",
    footerLogoAlt: "ديماكسستور — يربط المشترين بالموردين الأتراك",
    highlightLabelProductQuality: "جودة المنتج",
    highlightLabelProductSizes: "أحجام المنتج",
    highlightLabelPackageSizes: "أحجام التعبئة",
    highlightLabelPackageQuantitiesCarton: "الكميات في الكرتون",
    highlightLabelShelfLife: "مدة الصلاحية",
    highlightLabelPrivateLabel: "إنتاج تحت علامة خاصة",
    highlightLabelPrivateLabelShort: "علامة خاصة",
    highlightLabelNetWeight: "الوزن الصافي",
    highlightLabelStorage: "التخزين",
    highlightLabelIngredients: "المكونات",
    highlightLabelCertification: "الشهادة",
    highlightValueAvailable: "متوفر",
    highlightValueNotAvailable: "غير متوفر",
    highlightValueYes: "نعم",
    highlightValueNo: "لا",
  },
};

Object.assign(translations.en, I18N_SECTION_EN);
Object.assign(translations.fr, BLOG_I18N_FR);
Object.assign(translations.es, BLOG_I18N_ES);
Object.assign(translations.ar, BLOG_I18N_AR);
Object.assign(translations.fr, I18N_SECTION_FR);
Object.assign(translations.es, I18N_SECTION_ES);
Object.assign(translations.ar, I18N_SECTION_AR);

const LanguageContext = createContext();

const ALLOWED_LANGS = ['en', 'fr', 'es', 'ar'];

const LANG_STORAGE_KEY = 'demaxtore_lang';

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    try {
      const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
      if (saved && ALLOWED_LANGS.includes(saved)) return saved;
    } catch {
      /* ignore */
    }
    return 'en';
  });
  const setLang = useCallback((next) => {
    const v = next === 'tr' ? 'en' : next;
    const resolved = ALLOWED_LANGS.includes(v) ? v : 'en';
    setLangState(resolved);
    try {
      window.localStorage.setItem(LANG_STORAGE_KEY, resolved);
    } catch {
      /* ignore */
    }
  }, []);
  const languages = useMemo(() => [...ALLOWED_LANGS], []);
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  const toggleLang = () =>
    setLangState((prev) => {
      const i = languages.indexOf(prev);
      const idx = i < 0 ? 0 : (i + 1) % languages.length;
      const next = languages[idx];
      try {
        window.localStorage.setItem(LANG_STORAGE_KEY, next);
      } catch {
        /* ignore */
      }
      return next;
    });
  /** en, fr, es, ar — extra args from older call sites are ignored */
  const tl = (en, fr, es, ar) => {
    const map = { en, fr, es, ar };
    return map[lang] ?? en;
  };
  const languageLabel = { en: 'EN', fr: 'FR', es: 'ES', ar: 'AR' }[lang] || 'EN';
  const isRTL = false;

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.lang =
      lang === 'ar' ? 'ar' : lang === 'fr' ? 'fr' : lang === 'es' ? 'es' : 'en';
    document.documentElement.dir = 'ltr';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, tl, languageLabel, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
